<template>
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-8">
        <CustomAlert v-if="activityInstructions" class="mb-4">
          {{ activityInstructions }}
        </CustomAlert>

        <div class="d-flex justify-content-end mb-4" v-if="useReport">
          <RouterLink
            :to="{ name: 'Report', params: { onid: 'nogglema' } }"
            class="btn btn-light border border-dark d-flex align-items-center gap-2 fw-bold shadow-sm py-1"
          >
            <i class="bi bi-list-task fs-5"></i>
            <div>Report</div>
          </RouterLink>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="sticky-top">
              <TableOfContents :isLocked="false" />
            </div>
          </div>
          <div class="col-sm-8">
            <div
              v-for="step in getSteps()"
              :key="step.id"
              :id="step.id"
              class="mb-4"
            >
              <PromptContainer :step="step" />
            </div>
          </div>
        </div>

        <pre class="text-start" v-if="0">
          {{ getSteps }}
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import content from "@/data/content.json";
import TableOfContents from "@/components/activity/TableOfContents.vue";
import PromptContainer from "@/components/activity/PromptContainer.vue";

export default {
  name: "LongFormView",
  components: {
    TableOfContents,
    PromptContainer
  },
  computed: {
    ...mapGetters(["getSteps", "getCurrentStepId", "useReport"]),
    activityInstructions() {
      return content.activityInstructions;
    }
  }
};
</script>

<style scoped>
.sticky-top {
  top: 20px;
}
</style>
